import { render, staticRenderFns } from "./ShippingFactorInput.vue?vue&type=template&id=07327070&scoped=true"
import script from "./ShippingFactorInput.vue?vue&type=script&lang=ts"
export * from "./ShippingFactorInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07327070",
  null
  
)

export default component.exports